import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from '../../shared/shared.module';

import { HeaderComponent } from './header.component';
import { HeaderSearchComponent } from './search/header-search.component';
import { HeaderNotificationComponent } from './notification/header-notification.component';
import { SearchPortalParentComponent } from './search-portal/search-portal-parent/search-portal-parent.component';
import { NotificationsMenuComponent } from './notifications-menu/notifications-menu.component';
import { SidePanelComponent } from './side-panel/side-panel.component';

@NgModule({
  imports: [
    SharedModule,
    MatMenuModule
  ],
  declarations: [
    HeaderComponent,
    HeaderSearchComponent,
    HeaderNotificationComponent,
    SearchPortalParentComponent,
    NotificationsMenuComponent,
    SidePanelComponent
  ],
  exports: [HeaderComponent]
})
export class HeaderModule {}
